export default __webpack_public_path__ + "static/media/IR.6b8610f3.svg";